module.exports = __webpack_public_path__ + "img/y.3db9c023.png";